// tslint:disable:max-line-length

import React from 'react';

export const ObjectView = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 18 16" {...props}>
      <path
        d="M16.9688 10L17 8.5C17 7.125 15.875 6 14.5 6C13.0938 6 12 7.125 12 8.5V10C11.4375 10 11 10.4688 11 11.0312V15C11 15.5625 11.4375 16 12 16H16.9688C17.5312 16 18 15.5625 18 15V11C18 10.4688 17.5312 10 16.9688 10ZM15.5 10H13.5V8.5C13.5 7.96875 13.9375 7.5 14.5 7.5C15.0312 7.5 15.5 7.96875 15.5 8.5V10ZM11.25 6C11.6562 6 12 5.6875 12 5.28125V4.34375C12 3.8125 11.7812 3.3125 11.4062 2.9375L9.0625 0.59375C8.6875 0.21875 8.1875 0 7.65625 0H2C0.875 0 0 0.90625 0 2V14C0 15.125 0.875 16 2 16H9.25C9.65625 16 10 15.6875 10 15.2812V15.25C10 14.8438 9.65625 14.5 9.25 14.5H2C1.71875 14.5 1.5 14.2812 1.5 14V2.03125C1.5 1.75 1.71875 1.53125 2 1.53125H7V4C7 4.53125 7.4375 5 8 5H10.5V5.25C10.5 5.6875 10.8125 6 11.2188 6H11.25Z"
        fill="#616365"
      />
    </svg>
  );
};
